import React, { FC } from 'react'

import { ampli, NavLinkClickProperties } from '@Analytics/ampli'

type AProps = React.JSX.IntrinsicElements['a']

export interface LinkProps extends AProps {
  analytics?: NavLinkClickProperties
}

export const Link: FC<LinkProps> = (
  {
    analytics,
    children,
    onClick,
    target,
    ...rest
  }: LinkProps,
) => (
  <a
    data-mp-link
    onClick={(e) => {
      if (analytics) {
        ampli.navLinkClick(analytics)
      }

      if (onClick) {
        onClick(e)
      }
    }}
    target={target}
    {...rest}
  >
    {children}
  </a>
)
